import { call, put, select } from 'redux-saga/effects';

import { resetPartnerPatient } from 'connect/actions';
import { extractErrorMessage, sendToLogger } from 'connect/saga/helpers';

import { selectDataPartnerPatient, selectDataUser } from 'connect/selectors';
import { apiCreatePatientForPartner } from 'endpoints/partner-endpoints';

import { SagaHandler } from '../SagaHandler';

/**
 * SagaHandler for handling the creation of a partner's patient.
 *
 * TODO: Refactor the parent SagaHandler to use TypeScript
 *  and add a function to wrap all try/catch/finally logic in the saga function.
 */
class _CreatePartnerPatient extends SagaHandler {
  constructor() {
    super({
      actionName: 'data/CREATE_PARTNER_PATIENT',
      stateKey: 'createPartnerPatient',
    });
  }

  createAction(patientData) {
    return { type: this._actionName, patientData };
  }

  * saga({ patientData }) {
    try {
      yield put(this.error.update(null));
      yield put(this.success.update(false));
      yield put(this.loading.update(true));

      let patient = yield select(selectDataPartnerPatient);

      // Call the partner API to create a patient only
      // if the stored patient data is missing or the email field doesn't match.
      if (!patient || patient.email !== patientData.email) {
        const currentUser = yield select(selectDataUser);
        const result = yield call(
          apiCreatePatientForPartner,
          currentUser?.partner?.id,
          patientData,
        );
        patient = result.patient;
      }

      yield put(this.value.update(patient));
      yield put(resetPartnerPatient(patient));
      yield put(this.success.update(true));
    } catch (err) {
      sendToLogger(err, 'createPartnerPatient', { patientData });
      yield put(this.error.update(extractErrorMessage(err)));
      yield put(this.success.update(false));
    } finally {
      yield put(this.loading.update(false));
    }
  }
}

export const CreatePartnerPatient = new _CreatePartnerPatient();
